/**
 * @description: 避免首次执行的useEffect
 */
import { useEffect, useRef } from 'react';

var useUpdateEffect = function useUpdateEffect(effect) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  // 初始状态为false
  var canMount = useRef(false);
  useEffect(function () {
    // 初始状态
    if (!canMount.current) {
      canMount.current = true;
    } else {
      return effect();
    }
  }, deps);
};

export default useUpdateEffect;